import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue' 
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  mixins: [mixx],
  name: 'trxtarjetas',
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      ventas: [],

      f_c: {
        desde: this.date_rest(this.currentdate(), -15),
        hasta: this.currentdate(),
        estado: false,
      }

    };
  },

  computed: {
    reporte: function () {
      return (
        "/loteip/detalle/cupones/recibido?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },

  mounted: function () {
    console.log("hei: " + window.innerHeight)
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    console.log("hei2: " + window.innerHeight);
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      "autoWidth": false,
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
      "columnDefs": [
        { className: "dt-right", "targets": [12, 13] },
      ]


    });
    $('.box').boxWidget();

  },

  components: {
    barra,
    barrais,
    foot,
    barrade
  },
  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();

      this.$http
        .post('/loteip/detalle/cupones/recibido', this.f_c)
        .then(response => {
          this.ventast_tabla = 0;

          if (response.data.status == 1) {
            for (let i = 0; i < response.data.data.length; i++) {
              response.data.data[i][16] = this.num_to_many(parseFloat(response.data.data[i][16]).toFixed(2));
              response.data.data[i][17] = this.num_to_many(parseFloat(response.data.data[i][17]).toFixed(2));
              this.tbv.row.add(response.data.data[i]);
            }
          }

          this.tbv.draw();

          this.loading = false;
        });

    },

  }
}



// WEBPACK FOOTER //
// ./src/components/posintegrado/detalleCuponesFechaRecibido/index.js